/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Checkbox, Error, Input, Label, Radio } from 'app/components';
import {
  getPostValidationError,
  getPreValidationError,
  getPreValidationFieldError
} from 'app/utils';
import { FieldRenderProps } from '../DataInputs';

const propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired,
  errors: PropTypes.arrayOf(PropTypes.object),
  dataFields: PropTypes.shape({
    program: PropTypes.shape(FieldRenderProps),
    inclusiveType: PropTypes.shape(FieldRenderProps),
    filmTitle: PropTypes.shape(FieldRenderProps),
    privateParty: PropTypes.shape(FieldRenderProps),
    seminar: PropTypes.shape(FieldRenderProps),
    incentive: PropTypes.shape(FieldRenderProps),
    award: PropTypes.shape(FieldRenderProps),
    product: PropTypes.shape(FieldRenderProps),
    promotion: PropTypes.shape(FieldRenderProps),
    cultural: PropTypes.shape(FieldRenderProps),
    other: PropTypes.shape(FieldRenderProps),
    eventDescription: PropTypes.shape(FieldRenderProps)
  }).isRequired,
  submitFailed: PropTypes.bool.isRequired
};

const defaultProps = {
  errors: []
};

const ProgramInput = ({
  form,
  errors,
  dataFields: {
    program,
    inclusiveType,
    filmTitle,
    privateParty,
    seminar,
    incentive,
    award,
    product,
    promotion,
    cultural,
    other,
    eventDescription
  },
  submitFailed
}) => {
  const [t] = useTranslation();

  const setErrors = useCallback(() => {
    if (inclusiveType.input.value === 'own film (format Blu Ray or DCP)') {
      return (
        getPreValidationFieldError(filmTitle, t) ||
        getPostValidationError(errors, filmTitle.input.name, t)
      );
    }

    return false;
  }, [inclusiveType.input.value, filmTitle, errors]);

  // const handleEventChange = useCallback(item => {
  //   const events = [...dataFields.eventType.input.value];

  //   if (Array.isArray(events)) {
  //     if (events.includes(item)) {
  //       events.splice(events.indexOf(item), 1);
  //     } else {
  //       events.push(item);
  //     }
  //   } else {
  //     events.push(item);
  //   }
  //   form.change(dataFields.eventType.input.name, events);
  // }, [dataFields.eventType.input.value]);

  return (
    <div className="cinema-rent__programs-events-wrapper">
      <div className="cinema-rent__program-wrapper">
        <h2>{t('cinema_rent_inquiry_form.program_options')} *</h2>
        <div className="cinema-rent__program-container">
          <Label className="cinema-rent__program-radio">
            <Radio
              id="programOptions"
              checked={program.input.value === 'inclusiveFilms'}
              title="index"
              value="inclusiveFilms"
              onChange={e => form.change(program.input.name, e.target.value)}
            />
            <h3>{t('cinema_rent_inquiry_form.inclusive_film')}</h3>
          </Label>
          {program.input.value === 'inclusiveFilms' && (
            <div className="cinema-rent__program-inclusive-films-wrapper">
              <Label className="cinema-rent__program-radio">
                <Radio
                  id="from our current cinema program"
                  checked={inclusiveType.input.value === 'from our current cinema program'}
                  title="index"
                  value="from our current cinema program"
                  onChange={e => form.change(inclusiveType.input.name, e.target.value)}
                />
                <h3>{t('cinema_rent_inquiry_form.current_film')}</h3>
              </Label>
              <Label className="cinema-rent__program-radio">
                <Radio
                  id="own film (format Blu Ray or DCP)"
                  checked={inclusiveType.input.value === 'own film (format Blu Ray or DCP)'}
                  title="index"
                  value="own film (format Blu Ray or DCP)"
                  onChange={e => form.change(inclusiveType.input.name, e.target.value)}
                />
                <h3>{t('cinema_rent_inquiry_form.own_film')}</h3>
              </Label>
              {/* {submitFailed && inclusiveType.meta.error && (
                <Error>{t(...inclusiveType.meta.error)}</Error>
              )} */}
              <div className="cinema-rent__program-input">
                <Input
                  placeholder={t('cinema_rent_inquiry_form.film_placeholder')}
                  id={filmTitle.input.name}
                  {...filmTitle.input}
                  type="text"
                  error={setErrors()}
                />
              </div>
            </div>
          )}
          <Label className="cinema-rent__program-radio">
            <Radio
              id="programOptions"
              checked={program.input.value === 'exclusiveFilms'}
              title="index"
              value="exclusiveFilms"
              onChange={e => form.change(program.input.name, e.target.value)}
            />
            <h3>{t('cinema_rent_inquiry_form.exclusive_film')}</h3>
          </Label>
          {submitFailed && program.meta.error && <Error>{t(...program.meta.error)}</Error>}
        </div>
      </div>
      <div className="cinema-rent__event-wrapper">
        <h2>{t('cinema_rent_inquiry_form.type_of_event')}</h2>
        <div className="cinema-rent__event-container">
          <div className="cinema-rent__event-left">
            <Label className="cinema-rent__event-checkbox">
              <Checkbox
                id="Private party / Birthday"
                value="Private party / Birthday"
                checked={privateParty.input.value}
                onChange={e => form.change(privateParty.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.birthday_party')}</h3>
            </Label>
            <Label className="cinema-rent__event-checkbox">
              <Checkbox
                id="Seminar / Meeting / Conference"
                value="Seminar / Meeting / Conference"
                checked={seminar.input.value}
                onChange={e => form.change(seminar.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.seminar')}</h3>
            </Label>
            <Label className="cinema-rent__event-checkbox">
              <Checkbox
                id="Incentive"
                value="Incentive"
                checked={incentive.input.value}
                onChange={e => form.change(incentive.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.incentive')}</h3>
            </Label>
            <Label className="cinema-rent__event-checkbox">
              <Checkbox
                id="Award ceremony"
                value="Award ceremony"
                checked={award.input.value}
                onChange={e => form.change(award.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.award_ceremony')}</h3>
            </Label>
          </div>
          <div className="cinema-rent__event-right">
            <Label className="cinema-rent__event-checkbox">
              <Checkbox
                id="Product presentation"
                value="Product presentation"
                checked={product.input.value}
                onChange={e => form.change(product.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.product_presentation')}</h3>
            </Label>
            <Label className="cinema-rent__event-checkbox">
              <Checkbox
                id="Promotion"
                value="Promotion"
                checked={promotion.input.value}
                onChange={e => form.change(promotion.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.promotion')}</h3>
            </Label>
            <Label className="cinema-rent__event-checkbox">
              <Checkbox
                id="Cultural event (cabaret, or similar)"
                value="Cultural event (cabaret, or similar)"
                checked={cultural.input.value}
                onChange={e => form.change(cultural.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.cultural_event')}</h3>
            </Label>
            <Label className="cinema-rent__event-checkbox">
              <Checkbox
                id="Other"
                value="Other"
                checked={other.input.value}
                onChange={e => form.change(other.input.name, e.currentTarget.checked)}
              />
              <h3>{t('cinema_rent_inquiry_form.other')}</h3>
            </Label>
            <div className="cinema-rent__event-input">
              <Input
                placeholder={t('cinema_rent_inquiry_form.description_placeholder')}
                id={eventDescription.input.name}
                type="text"
                {...eventDescription.input}
                error={
                  getPreValidationError(eventDescription, t) ||
                  getPostValidationError(errors, eventDescription.input.name, t)
                }
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProgramInput.propTypes = propTypes;
ProgramInput.defaultProps = defaultProps;

export default memo(ProgramInput);
